import {
  BoxShopSalesResultDtoSchema,
  type BoxShopSalesInputDto,
  type BoxShopSalesMailDto,
  type BoxShopSalesResultDto,
} from "@/modules/boxShop/gateway/boxShopSalesApiDto"
import type { BoxShopSalesApiGateway } from "@/modules/boxShop/gateway/boxShopSalesApiGateway"
import { LoggerService } from "@modules/common/logger/loggerService"
import type { ApiClient } from "@/modules/core/api/client/apiClient"

export class BoxShopSalesApi implements BoxShopSalesApiGateway {
  private salesApiUrl = `box/shop/sales`

  constructor(private api: ApiClient) {}

  async createSale(sale: BoxShopSalesInputDto): Promise<BoxShopSalesResultDto> {
    const response = await this.api.post<BoxShopSalesResultDto>(`${this.salesApiUrl}`, sale)
    return LoggerService.parseApiDto(BoxShopSalesResultDtoSchema, response.data)
  }

  async sendEmail(saleId: string, input: BoxShopSalesMailDto): Promise<void> {
    await this.api.post(`${this.salesApiUrl}/${saleId}/mail`, input)
  }
}
